var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1367 19.7227L59.6836 2.26566C59.1032 1.68514 58.4142 1.22464 57.6558 0.91046C56.8974 0.596279 56.0846 0.43457 55.2637 0.43457C54.4428 0.43457 53.63 0.596279 52.8716 0.91046C52.1132 1.22464 51.4242 1.68514 50.8438 2.26566L2.67581 50.4375C2.09292 51.0158 1.63079 51.7042 1.31628 52.4626C1.00177 53.221 0.841158 54.0344 0.843782 54.8555V72.3125C0.843782 73.9701 1.50226 75.5598 2.67436 76.7319C3.84647 77.9041 5.43618 78.5625 7.09378 78.5625H24.5508C25.3719 78.5652 26.1853 78.4045 26.9437 78.09C27.7022 77.7755 28.3905 77.3134 28.9688 76.7305L77.1367 28.5625C77.7173 27.9821 78.1778 27.2931 78.4919 26.5347C78.8061 25.7763 78.9678 24.9635 78.9678 24.1426C78.9678 23.3217 78.8061 22.5089 78.4919 21.7505C78.1778 20.9921 77.7173 20.3031 77.1367 19.7227ZM8.38675 53.5625L41.4688 20.4805L47.9883 27L14.9063 60.0782L8.38675 53.5625ZM7.09378 61.1055L18.3008 72.3125H7.09378V61.1055ZM25.8438 71.0196L19.3242 64.5L52.4063 31.418L58.9258 37.9375L25.8438 71.0196ZM63.3438 33.5196L45.8867 16.0625L55.2617 6.68753L72.7188 24.1407L63.3438 33.5196Z",
    fill: "#5D5669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon2);
export default __webpack_public_path__ + "static/media/pencilIcon2.ddea436ba45959d77a6ae9c7785fa9a1.svg";
export { ForwardRef as ReactComponent };